import type { RouteObject } from "react-router-dom";
import { InboxPage } from "./InboxPage";

/** `/inbox` is the list; `/inbox/:id` is a thread (a screen on a phone, the right pane from 768px). */
export const routes: RouteObject[] = [
  { path: "inbox", element: <InboxPage /> },
  { path: "inbox/:id", element: <InboxPage /> },
];
